module.exports = __webpack_public_path__ + "media/images/ceremony/top/img_ceremony-9e7d53156e819580901fcc2471bff6f3.jpg";